export default __webpack_public_path__ + "static/media/diamond.92e2f6ad.svg";